import React from 'react';
import axios from 'axios';
import { Spin, Empty, Badge, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import * as serverconfig from '../../serverconn';
import * as serversocketconfig from '../../serversocketconfig';
import ReconnectingWebSocket from 'reconnecting-websocket';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import PolylineMap from '../components/PolylineMap';
import ProfessionalLayout from '../../../components/ProfessionalLayout';

const CryptoJS = require("crypto-js");
const { Text } = Typography;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

// Initialize WebSocket with better error handling
let agentlocationsocket = null;
try {
  agentlocationsocket = new ReconnectingWebSocket(serversocketconfig.socketurl+'/ws/agentlocationsocket/', [], {
    connectionTimeout: 1000,
    maxRetries: 3,
    reconnectInterval: 5000
  });
} catch (error) {
  console.warn('WebSocket connection not available. Using polling fallback.');
}

let token = '';
let sacco = '';

class Hub_OnlineAgentsList extends React.Component {
  state = {
    datarequested: true,
    delivery_agent_accounts: [],
  };

  componentDidMount() {
    this.initializeAuth();
    this.loadHubAgents();
    this.setupWebSocket();
    this.startPolling();
  }

  componentWillUnmount() {
    if (agentlocationsocket) {
      agentlocationsocket.close();
    }
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  initializeAuth = () => {
    if (localStorage.getItem("sacco")) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem("sacco"), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    }
    
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    };
  }

  loadHubAgents = () => {
    this.setState({ datarequested: true });
    
    const hubId = localStorage.getItem("coodinated_hub");
    axios.get(`${serverconfig.backendserverurl}/customqueries/get_hubagents/${hubId}`)
      .then(res => {
        this.setState({
          delivery_agent_accounts: JSON.parse(res.data.report),
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading hub agents:', error);
        this.setState({ datarequested: false });
      });
  }

  setupWebSocket = () => {
    if (!agentlocationsocket) return;

    agentlocationsocket.onmessage = async (e) => {
      // Refresh agent locations when updates are received
      this.loadHubAgents();
    };

    agentlocationsocket.onopen = () => {
      console.log('Hub agent location socket connected');
    };

    agentlocationsocket.onerror = (error) => {
      console.warn('WebSocket connection error. Using polling fallback.');
    };

    agentlocationsocket.onclose = () => {
      console.warn('WebSocket connection closed. Using polling fallback.');
    };
  }

  startPolling = () => {
    // Fallback polling every 30 seconds when WebSocket is not available
    this.pollingInterval = setInterval(() => {
      this.loadHubAgents();
    }, 30000);
  }

  render() {
    const { datarequested, delivery_agent_accounts } = this.state;

    const headerActions = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Badge 
          count={delivery_agent_accounts.length} 
          style={{ 
            backgroundColor: '#1890ff',
            color: '#fff',
            fontWeight: 'bold'
          }}
        >
          <Text strong style={{ marginRight: 8 }}>Hub Agents</Text>
        </Badge>
        {datarequested && <Spin indicator={antIcon} />}
      </div>
    );

    const hubId = localStorage.getItem("coodinated_hub");
    const hubName = localStorage.getItem("hub_name") || "Current Hub";

    return (
      <ProfessionalLayout
        title="Hub Agent Tracking"
        subtitle={`Real-time monitoring of agents assigned to ${hubName}`}
        icon={<SportsMotorsportsIcon />}
        headerActions={headerActions}
        loading={datarequested}
      >
        {!datarequested && (
          <>
            {delivery_agent_accounts.length > 0 ? (
              <div className="professional-map-container">
                <PolylineMap initialCoordinates={delivery_agent_accounts} />
              </div>
            ) : (
              <div className="professional-empty-state">
                <Empty
                  description={
                    <div>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        No agents are currently active for this hub
                      </Text>
                      <br />
                      <Text type="secondary" style={{ fontSize: 14 }}>
                        Agents assigned to {hubName} will appear here when online
                      </Text>
                    </div>
                  }
                  imageStyle={{ height: 80 }}
                />
              </div>
            )}
          </>
        )}
      </ProfessionalLayout>
    );
  }
}

export default Hub_OnlineAgentsList; 
